import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  FormHelperText,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useFormik } from "formik";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BillingStatementFilter(props) {
  const { open, handleClose, filter, setFilter, filterInitial, submitFilter } =
    props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [localFilter, setLocalFilter] = useState(filter);
  console.log(filter, "filter from model invoice");

  const handleChangeBillingEndDate = (val) => {
    const formattedDate = dayjs(val).format("YYYY-MM-DD");
    setLocalFilter({
      ...localFilter,
      billingEndDate: formattedDate,
      billingEndDateDatepicker: val,
    });
  };

  const handleChangeBillingStartDate = (val) => {
    const formattedDate = dayjs(val).format("YYYY-MM-DD");
    setLocalFilter({
      ...localFilter,
      billingStartDate: formattedDate,
      billingStartDateDatepicker: val,
    });
  };

  const handleChangeCustomer = (event) => {
    const {
      target: { value },
    } = event;
    setLocalFilter({ ...localFilter, invoiceStatus: value });
  };

  const resetFun = () => {
    setLocalFilter(filterInitial);
  };

  const validateDates = (values) => {
    let errors = {};
    const start = values.billingStartDateDatepicker
      ? dayjs(values.billingStartDateDatepicker)
      : null;
    const end = values.billingEndDateDatepicker
      ? dayjs(values.billingEndDateDatepicker)
      : null;
    console.log(start, "startstart");
    console.log(end, "endendend");
    console.log(values, "valuesvalues");
    console.log(errors, "errorserrors");
    // Start date validation
    // if (!start || !start.isValid()) {
    //   errors.billingStartDateDatepicker = "Invalid start date.";
    // }
    if (!start && end) {
      errors.billingStartDateDatepicker = "Start date is required.";
    } else if (start && !start.isValid()) {
      errors.billingStartDateDatepicker = "Invalid date";
    }
    // End date validation
    // if (!end || !end.isValid()) {
    //   errors.billingEndDateDatepicker = "Invalid end date.";
    // }

    if (!end && start) {
      errors.billingEndDateDatepicker = "End date is required.";
    } else if (end && !end.isValid()) {
      errors.billingEndDateDatepicker = "Invalid date";
    }

    if (
      start &&
      end &&
      start.isValid() &&
      end.isValid() &&
      !start.isBefore(end) &&
      !start.isSame(end)
    ) {
      errors.billingStartDateDatepicker =
        "Start date must be before the end date.";
      errors.billingEndDateDatepicker =
        "End date must be after the start date.";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: localFilter,
    enableReinitialize: true,
    validate: validateDates,
    onSubmit: (values) => {
      formik.validateForm().then((errors) => {
        if (!Object.keys(errors).length) {
          setFilter(localFilter); // Apply local filter to main filter
          submitFilter();
        }
      });
    },
  });

  const { errors, touched, handleSubmit, setValues } = formik;

  const clearProject = () => {
    setLocalFilter({ ...localFilter, invoiceStatus: "" });
  };

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={() => {
          setLocalFilter(filter); // Reset local filter to main filter
          handleClose();
        }}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={
              <span className="material-symbols-outlined">history</span>
            }
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <Stack direction="row" alignItems="flex-start" spacing={2}>
            <FormControl
              className="invoice-dt-field"
              sx={{ width: "100%" }}
              variant="standard"
              error={
                touched.billingStartDateDatepicker &&
                !!errors.billingStartDateDatepicker
              }
            >
              <p className="label">Billing Period Start Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="billingStartDate"
                  id="billingStartDate"
                  value={
                    localFilter.billingStartDateDatepicker
                      ? dayjs(localFilter.billingStartDateDatepicker)
                      : null
                  }
                  onChange={(dateValue) => {
                    handleChangeBillingStartDate(dateValue);
                  }}
                  shouldDisableDate={(date) =>
                    localFilter?.billingEndDateDatepicker &&
                    date.isAfter(localFilter.billingEndDateDatepicker, "day")
                  }
                  renderInput={(params) => <input {...params} />}
                />
              </LocalizationProvider>
              {touched.billingStartDateDatepicker &&
                errors.billingStartDateDatepicker && (
                  <FormHelperText>
                    {errors.billingStartDateDatepicker}
                  </FormHelperText>
                )}
            </FormControl>
            <FormControl
              className="invoice-dt-field"
              sx={{ width: "100%" }}
              variant="standard"
              error={
                touched.billingEndDateDatepicker &&
                !!errors.billingEndDateDatepicker
              }
            >
              <p className="label">Billing Period End Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="billingEndDate"
                  id="billingEndDate"
                  inputFormat="DD-MM-YYYY"
                  value={
                    localFilter.billingEndDateDatepicker
                      ? dayjs(localFilter.billingEndDateDatepicker)
                      : null
                  }
                  onChange={(dateValue) => {
                    handleChangeBillingEndDate(dateValue);
                  }}
                  shouldDisableDate={(date) =>
                    localFilter?.billingStartDateDatepicker &&
                    date.isBefore(localFilter.billingStartDateDatepicker, "day")
                  }
                  renderInput={(params) => <input {...params} />}
                />
              </LocalizationProvider>
              {touched.billingEndDateDatepicker &&
                errors.billingEndDateDatepicker && (
                  <FormHelperText>
                    {errors.billingEndDateDatepicker}
                  </FormHelperText>
                )}
            </FormControl>
          </Stack>

          <Stack
            sx={{ mt: "-5px" }}
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <FormControl
              className="search-box filter-searchbox"
              sx={{ m: 1, maxWidth: "357px" }}
            >
              <p className="label">Invoice Status</p>
              <Select
                sx={{
                  ".MuiSelect-select": {
                    color:
                      localFilter?.invoiceStatus === ""
                        ? "#898989 !important" // Gray color for placeholder
                        : "#212121 !important", // Black color for selected value
                  },
                  minWidth: localFilter?.invoiceStatus ? "0px" : "100%",
                  paddingRight: localFilter?.invoiceStatus ? "14px" : "0px",
                }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={localFilter.invoiceStatus || ""}
                onChange={handleChangeCustomer}
                IconComponent={KeyboardArrowDownIcon}
                displayEmpty
                endAdornment={
                  <InputAdornment position="start">
                    {localFilter.invoiceStatus ? (
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={clearProject}
                      >
                        <HighlightOffIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      ""
                      // <IconButton
                      //   size="small"
                      //   aria-label="close"
                      //   color="inherit"
                      // >
                      //   <KeyboardArrowDownIcon fontSize="small" />
                      // </IconButton>
                    )}
                  </InputAdornment>
                }
              >
                <MenuItem disabled value="" sx={{ color: "darkgray" }}>
                  Select Status
                </MenuItem>
                <MenuItem value={1}>Statement Pending</MenuItem>
                <MenuItem value={2}>Statement Ready</MenuItem>
                <MenuItem value={3}>Invoice Started</MenuItem>
                <MenuItem value={4}>Invoice Closed</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "15px" }}
        >
          <Button className="filter-btn" type="submit">
            Apply Filter
          </Button>
          <Button
            className="cancel-btn"
            onClick={() => {
              setLocalFilter(filter); // Reset local filter to main filter
              handleClose();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
